module.exports = __webpack_public_path__ + "img/icon-mood-inactive.480b1595.png";